/* eslint-disable react/prop-types */

import { sdGetPriorityColour } from "helpers/sdHelper";
import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";

const SDPrioritySelect = ({ initialValue, onUpdate, priorities }) => {
    const [selectedValue, setSelectedValue] = useState(initialValue);
    const [priorityColours, setPriorityColours] = useState({});

    useEffect(() => {
        let c = {};
        for (let i = 0; i < priorities.length; i++) {
            let priority = priorities[i];
            c[priority.id] = sdGetPriorityColour(priority.value)
        }
        setPriorityColours(c);
    }, []);

    const handleChange = async (e) => {
        const newValue = e.target.value;
        setSelectedValue(newValue);
        onUpdate(newValue);
    };

    return (
        <><Form.Select aria-label="Default select example" value={selectedValue} onChange={handleChange} style={{ backgroundColor: priorityColours[selectedValue]}}>
            {priorities.map((priority) => (
                <option key={priority.id} value={priority.id} style={{ backgroundColor: priorityColours[priority.id]}}>
                    {priority.name}
                </option>
            ))}

        </Form.Select></>
    );
}

export default SDPrioritySelect;